<template>
  <div>
    <breadcrumb activeName="广告管理" :breadcrumbItem="[{ to: '/marketing/ad', name: '广告管理' }]"></breadcrumb>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">
      {{ adposition.name }}广告管理
      <small>广告管理...</small>
    </h1>
    <!-- end page-header -->
    <panel title="广告列表" :noButton="true">
      <div slot="heading-btn">
        <button class="btn btn-theme btn-sm" type="button" @click="fn_add">
          <i class="fa fa-plus"></i> 添加广告
        </button>
        <button
          class="btn btn-theme btn-sm m-l-10"
          icon="md-arrow-round-back"
          @click="$router.go(-1)"
        >
          <i class="fa fa-arrow-left"></i> 返回
        </button>
      </div>
      <Table border size="small" :columns="columns" :data="data">
        <template slot-scope="{ row }" slot="status">
          <strong v-if="row.status == 0">有效</strong>
          <strong v-else style="color:red">无效</strong>
        </template>
        <template slot-scope="{ row }" slot="adtype">
          <span v-if="row.adtype == 'goods'">商品广告</span>
          <span v-else-if="row.adtype == 'artical'">内容广告</span>
          <!-- <span v-else-if="row.adtype=='active'">活动广告</span> -->
          <!-- <span v-else-if="row.adtype=='goodstype'">商品类型</span> -->
          <span v-else-if="row.adtype == 'goodscate'">商品目录</span>
          <span v-else>无链接</span>
        </template>
        <template slot-scope="{ row }" slot="logo">
          <span v-if="!is_movie(row.logo)">
            <img :src="logourl + row.logo" style="max-height:100px" />
          </span>
          <span v-else>视频</span>
        </template>
        <template slot-scope="{ row }" slot="expdate">
          开始:{{ row.begintime }}
          <br />
          结束:{{ row.endtime }}
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <button
            type="button"
            class="btn btn-theme btn-sm"
            style="margin-right: 5px"
            @click="fn_edit_ad(row, index)"
          >广告管理</button>

          <!-- <Poptip
            transfer
            confirm
            title="是否要删除此类型以及对应的属性?"
            @on-ok="fn_remove(row, index)"
            ok-text="确认"
            cancel-text="取消"
          >
            <button type="button" class="btn btn-danger btn-sm">作废</button>
          </Poptip>-->
        </template>
      </Table>
      <Page
        style="margin-top:10px"
        :total="totalRows"
        :current="currentPage"
        :page-size="pageNum"
        show-total
        show-elevator
        @on-change="fn_switchPage"
      />
    </panel>
    <Drawer
      title="广告信息"
      v-model="v_edit_ad"
      :width="drawerWidth"
      :mask-closable="true"
      @on-close="fn_close_drawer"
    >
      <Form :model="formData" ref="formData" :rules="rules" :labelWidth="150">
        <Row>
          <Col :span="colWidth">
            <FormItem label="广告名称" label-position="top" prop="name">
              <Input v-model="formData.name" placeholder="广告名称" />
            </FormItem>
            <FormItem label="广告类型" label-position="top" prop="adtype">
              <Select v-model="formData.adtype" @on-change="fn_change_adtype">
                <Option value="goods" label="商品广告"></Option>
                <!-- <Option value="active" label="活动广告"></Option> -->
                <Option value="artical" label="内容广告"></Option>
                <!-- <Option value="goodstype" label="商品类型"></Option> -->
                <Option value="goodscate" label="商品目录"></Option>
                <Option value="none" label="无链接"></Option>
              </Select>
            </FormItem>
            <FormItem label="商品" v-if="formData.adtype == 'goods'">
              <Select
                v-model="formData.goods_name"
                icon="ios-search"
                style="width:100%"
                remote
                transfer
                filterable
                :remote-method="fn_search_product"
                @on-change="fn_change_product"
              >
                <Option
                  v-for="(item, index) in remoteProductList"
                  :value="item.goods_name"
                  :label="item.goods_name"
                  :key="index"
                >{{ item.goods_sn }} {{ item.goods_name }}</Option>
              </Select>
            </FormItem>
            <FormItem label="商品类型" v-if="formData.adtype == 'goodstype'">
              <Select v-model="formData.goodstypeid">
                <Option
                  v-for="(item, index) in typeList"
                  :key="index"
                  :value="item.id"
                  :label="item.type_name"
                ></Option>
              </Select>
            </FormItem>
            <FormItem label="商品目录" v-if="formData.adtype == 'goodscate'">
              <Treeselect
                transfer
                v-model="formData.goodscateid"
                :multiple="false"
                :options="categoryTree"
              />
              <span class="help-block" style="color:red">选择第3级目录</span>
            </FormItem>
            <FormItem label="广告图片(视频mp4)" prop="logo">
              <Upload
                name="filename"
                :show-upload-list="false"
                :action="uploadhost"
                :format="['jpg', 'jpeg', 'png', 'mp4']"
                :on-success="fn_uploadSuccess"
                :max-size="2048"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                style="display: inline-block;width:90px;"
              >
                <Button icon="ios-cloud-upload-outline">上传图片(视频mp4)</Button>
              </Upload>
            </FormItem>
            <FormItem label="广告图片(视频)" v-if="formData.logo.length > 0">
              <img
                v-if="!is_movie(formData.logo)"
                :src="logourl + formData.logo"
                style="max-height:100px"
              />

              <video-player
                v-else
                class="video-player vjs-custom-skin video-size"
                ref="videoPlayer"
                :playsinline="true"
                :options="playerOptions"
              ></video-player>
            </FormItem>
            <FormItem label="背景色">
              <ColorPicker v-model="formData.background" />
            </FormItem>
            <FormItem label="开始时间" label-position="top" prop="begintime">
              <DatePicker
                type="datetime"
                v-model="formData.begintime"
                placeholder="Select date"
                style="width: 100%"
              ></DatePicker>
            </FormItem>
            <FormItem label="结束时间" label-position="top" prop="endtime">
              <DatePicker
                type="datetime"
                v-model="formData.endtime"
                placeholder="Select date"
                style="width: 100%"
              ></DatePicker>
            </FormItem>
            <FormItem label="状态" label-position="top">
              <Select v-model="formData.status">
                <Option :value="0">有效</Option>
                <Option :value="-1">无效</Option>
              </Select>
            </FormItem>
            <FormItem label="排序" label-position="top">
              <InputNumber style="width:100%" v-model="formData.sortval"></InputNumber>
            </FormItem>
            <FormItem label="备注">
              <div style="color:red">广告的商品，必须是上线状态,否则无法选择如广告里</div>
            </FormItem>
          </Col>
          <Col span="16" v-show="formData.adtype == 'artical'">
            <FormItem label="文字标题" label-position="top" prop="title">
              <Input v-model="formData.title" placeholder="广告标题" />
            </FormItem>
            <FormItem label="主要描述" label-position="top">
              <Input type="textarea" v-model="formData.breif" :rows="4" placeholder="请输入广告的主要描述" />
            </FormItem>
            <FormItem label="文字广告">
              <div class="editor-wrapper">
                <div :id="editorId"></div>
              </div>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div class="demo-drawer-footer">
        <button
          type="button"
          class="btn btn-default"
          style="margin-right: 8px"
          @click="v_edit_ad = false"
        >关闭</button>
        <button type="button" class="btn btn-theme" @click="fn_store_data">保存</button>
      </div>
    </Drawer>
  </div>
</template>
<script>
import "vue-video-player/src/custom-theme.css";
import "video.js/dist/video-js.css";

import { videoPlayer } from "vue-video-player";

import breadcrumb from "@/components/breadcrumb";
import Treeselect from "@riophae/vue-treeselect";
import moment from "moment";
import {
  getGoodsListByKeywords,
  getTypeList,
  getCategoryTreeSelect
} from "@/api/goods";

import { getToken } from "@/libs/util";
import config from "@/config";
import Editor from "wangeditor";
import "wangeditor/release/wangEditor.css";
import { storeAdData, getAdList } from "@/api/ad";
export default {
  components: { breadcrumb, Treeselect, videoPlayer },
  mounted() {
    let adposition = this.$route.params.data;
    if (typeof adposition == "undefined") {
      this.$Modal.info({
        title: "提示",
        content: "此页不支持刷新页面"
      });
      this.$router.go(-1);
      return;
    }
    this.adposition = adposition;
    this.iniRichText();
    let filterCond = {
      id: this.adposition.id,
      page: 1,
      pageNum: this.pageNum
    };
    this.fn_load_data(filterCond);
    getTypeList({ page: 0, pageNum: 0 })
      .then(res => {
        this.typeList = res.data;
      })
      .catch(error => {
        this.$Message.error(error);
      });
    getCategoryTreeSelect()
      .then(res => {
        this.categoryTree = [
          {
            id: 0,
            label: "目录顶级节点",
            children: res.data
          }
        ];
      })
      .catch(error => {
        this.$Message.error(error);
      });
  },
  computed: {
    editorId() {
      return `editor${this._uid}`;
    }
  },
  data() {
    return {
      typeList: [],
      categoryTree: [],
      drawerWidth: 40,
      colWidth: 24,
      uploadhost: config.baseUrl.pro + "/upload/uploadfile",
      logourl: config.baseUrl.imageurl,
      adposition: {},
      columns: [
        {
          title: "名称",
          key: "name",
          width: 150
        },
        {
          title: "图标(视频)",
          slot: "logo",
          width: 400
        },
        {
          title: "广告类型",
          slot: "adtype",
          width: 150
        },
        {
          title: "时间",
          slot: "expdate"
        },
        {
          title: "排序",
          key: "sortval",
          width: 100
        },
        {
          title: "状态",
          slot: "status",
          width: 120
        },
        {
          title: "操作",
          slot: "action",
          width: 280,
          align: "left"
        }
      ],
      data: [],
      remoteProductList: [],
      totalRows: 0,
      pageNum: 10,
      currentPage: 1,
      v_edit_ad: false,
      formData: {
        id: 0,
        adpositionid: 0,
        name: "",
        logo: "",
        background: "#00ff00",
        adtype: "",
        title: "",
        breif: "",
        adcontent: "",
        goodsid: 0,
        activeid: 0,
        begintime: "",
        endtime: "",
        status: 0,
        sortval: 0,
        goodstypeid: 0,
        goodscateid: 0
      },
      playerOptions: {},
      rules: {
        name: [
          {
            required: true,
            message: "广告名称不能为空",
            trigger: "blur"
          }
        ],
        adtype: [
          {
            required: true,
            message: "广告类型不能为空",
            trigger: "change"
          }
        ],
        logo: [
          {
            required: true,
            message: "广告图片不能为空",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    /**
     * 判断url 的后缀，如果是图片，则返回true
     */
    is_movie(url) {
      let urlSplit = url.split(".");

      if (urlSplit[1] == "mp4") return true;
      else return false;
    },
    fn_close_drawer() {
      this.formData.begintime = moment(this.formData.begintime).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.formData.endtime = moment(this.formData.endtime).format(
        "YYYY-MM-DD HH:mm:ss"
      );
    },
    fn_change_adtype(node) {
      if (node == "artical") {
        this.drawerWidth = 80;
        this.colWidth = 8;
      } else {
        this.drawerWidth = 40;
        this.colWidth = 24;
      }
    },
    fn_load_data(filterCond) {
      getAdList(filterCond)
        .then(res => {
          this.data = res.data.data;
          this.totalRows = res.data.total;
        })
        .catch(error => {
          this.$Message.error(error);
        });
    },
    fn_add() {
      this.v_edit_ad = true;
      this.formData = {
        id: 0,
        adpositionid: 0,
        name: "",
        logo: "*.jpeg",
        background: "#00ff00",
        adtype: "",
        title: "",
        breif: "",
        adcontent: "",
        goodsid: 0,
        activeid: 0,
        begintime: moment().format("YYYY-MM-DD HH:mm:ss"),
        endtime: moment()
          .add(180, "days")
          .format("YYYY-MM-DD HH:mm:ss"),
        status: 0,
        sortval: 0
      };
    },
    fn_edit_ad(row, index) {
      this.formData = row;

      this.playerOptions = {
        //播放速度
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        //如果true,浏览器准备好时开始回放。
        autoplay: false,
        // 默认情况下将会消除任何音频。
        muted: false,
        // 导致视频一结束就重新开始。
        loop: false,
        // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        preload: "auto",
        language: "zh-CN",
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        aspectRatio: "16:9",
        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        fluid: true,
        sources: [
          {
            //类型
            type: "video/mp4",
            //url地址
            src: this.logourl + row.logo
          }
        ],
        //你的封面地址
        poster: "",
        //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          //全屏按钮
          fullscreenToggle: true
        }
      };

      this.editor.txt.html(this.formData.adcontent);
      this.v_edit_ad = true;
      if (row.adtype == "artical") {
        this.drawerWidth = 80;
        this.colWidth = 8;
      }
    },
    fn_switchPage(page) {
      this.currentPage = page;
      let filterCond = {
        page: page,
        pageNum: this.pageNum,
        id: this.adposition.id
      };
      this.fn_load_data(filterCond);
    },
    fn_store_data() {
      this.formData.adpositionid = this.adposition.id;
      this.formData.begintime = moment(this.formData.begintime).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.formData.endtime = moment(this.formData.endtime).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.$refs.formData.validate(valid => {
        if (valid) {
          storeAdData(this.formData)
            .then(res => {
              if (res.data.code == 200) {
                if (this.formData.id == 0) {
                  this.data.push(res.data.data);
                }
                this.v_edit_ad = false;
                this.$Notice.success(res.data);
              } else {
                this.$Notice.error(res.data);
              }
            })
            .catch(error => {
              this.$Message.error(error);
            });
        }
      });
    },
    fn_uploadSuccess(res, file) {
      if (file.response.code === 200) {
        this.formData.logo = file.response.data;
      }
    },

    handleFormatError(file) {
      this.$Notice.warning({
        title: "文件格式不正确",
        desc:
          "文件 " + file.name + " 格式不正确，请上传 jpg 或 png 格式的图片。"
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "超出文件大小限制",
        desc: "文件 " + file.name + " 太大，不能超过 2M。"
      });
    },
    fn_search_product(keywords) {
      getGoodsListByKeywords(keywords)
        .then(res => {
          this.remoteProductList = res.data;
        })
        .catch(error => {
          this.$Message.error(error);
        });
    },
    fn_change_product(node) {
      this.formData.goodsid = this.remoteProductList[node].id;
    },
    iniRichText() {
      // console.log(this.Field.columname, this.FieldListData);
      this.editor = new Editor(`#${this.editorId}`);
      this.editor.customConfig.onchange = html => {
        let text = this.editor.txt.text();
        if (this.cache) localStorage.editorCache = html;
        this.$emit("input", this.valueType === "html" ? html : text);
        this.$emit("on-change", html, text);
      };
      this.editor.customConfig.onchangeTimeout = this.changeInterval;
      // create这个方法一定要在所有配置项之后调用
      this.editor.customConfig.zIndex = 1; // 设置菜单的垂直高度

      this.editor.customConfig.uploadImgServer = this.uploadhost;
      //  "http://47.106.198.122/api/CanteenAdmin/CanteenManagement/UploadImage"; // 配置服务器端地址
      this.editor.customConfig.uploadImgHeaders = {
        Authorization: "Bearer" + getToken()
      }; // 自定义 header
      this.editor.customConfig.uploadFileName = "filename"; // 后端接受上传文件的参数名
      this.editor.customConfig.uploadImgMaxSize = 2 * 1024 * 1024; // 将图片大小限制为 2M
      this.editor.customConfig.uploadImgMaxLength = 6; // 限制一次最多上传 3 张图片
      this.editor.customConfig.uploadImgTimeout = 3 * 60 * 1000; // 设置超时时间
      // this.editor.customConfig.uploadParams = {formFile:'2'};
      // 配置菜单
      this.editor.customConfig.menus = [
        "head",
        "bold", // 粗体
        "fontSize", // 字号
        "fontName", // 字体
        "italic", // 斜体
        "underline", // 下划线
        "strikeThrough", // 删除线
        "foreColor", // 文字颜色
        "backColor", // 背景颜色
        "link", // 插入链接
        "list", // 列表
        "justify", // 对齐方式
        "quote", // 引用
        "emoticon", // 表情
        "image", // 插入图片
        "table", // 表格
        "video", // 插入视频
        "code", // 插入代码
        "undo", // 撤销
        "redo" // 重复
      ];

      this.editor.customConfig.uploadImgHooks = {
        fail: (xhr, editor, result) => {
          // 插入图片失败回调
        },
        success: (xhr, editor, result) => {
          // 图片上传成功回调
          //
          let imgUrl = result.data;
          insertImg(imgUrl);
        },
        timeout: (xhr, editor) => {
          // 网络超时的回调
        },
        error: (xhr, editor) => {
          console.log(editor);
          // 图片上传错误的回调
        },
        customInsert: (insertImg, result, editor) => {
          // 图片上传成功,插入图片的回调

          // if(result.code == 200){
          var url = this.logourl + result.data;
          //   console.log(url);
          insertImg(url); //将内容插入到富文本中
          // console.log(insertImg(url)+"DFDF")
          // console.log(data+"dsfd")
          // }
        }
      };

      this.editor.customConfig.onchange = html => {
        this.info_ = html; // 绑定当前逐渐地值
        this.$emit("change", this.info_); // 将内容同步到父组件中
        this.formData.adcontent = html;
      };

      // 创建富文本编辑器

      this.editor.create();
      // 如果本地有存储加载本地存储内容
    }
  }
};
</script>
<style scoped></style>
